// Parshva S - 12/12/2023 - BT-123521 : Breeze - Header Indices Start
import { useCallback, useEffect, useMemo, useState } from 'react'
import { BzDropdown, BzInputText, BzModal, BzModalBody, BzModalHeader } from '../../components'
import { Col, Container, Dropdown, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { handleModal, handleModalData } from '../../redux/actions/modals'
import { changeDataInGridFormat } from '../../utils/global_functions'
import { toastConfig } from '../../redux/actions/toast';
const ChangeHeaderIndicesModal = ({ onSelect = () => { } }) => {

    const [arrLocalDetails, setArrLocalDetails] = useState(null);
    const [selectedIndice, setSelectedIndice] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [initialIndice, setInitialIndice] = useState(null);
    const headerIndices = useSelector(state => state?.indices?.headerIndices);
    const [zeroState, setZeroState] = useState(false);
    const modals = useSelector(state => state?.modals?.modals)
    const modalData = useSelector(state => state?.modals?.modalData)
    const localIndices = useSelector(state => state?.indices?.localIndices);
    const dispatch = useDispatch()

    const indiceExchangeList = useMemo(() => {
        const exchangeList = [];
        if (localIndices?.length) {
            localIndices.forEach(indice => {
                let exchangeName = indice.exchangeName;
                if (exchangeList.indexOf(exchangeName) === -1 && exchangeName) {
                    exchangeList.push(exchangeName);
                }
            });
        }
        setInitialIndice(exchangeList[0])
        return exchangeList;
    }, [localIndices]);

    const onExchangeFilter = useCallback((selectedExchange) => {
        if (localIndices?.length) {
            const sortedArr = localIndices?.filter(indice => indice?.exchangeName === selectedExchange);
            const updatedLocalDetails = changeDataInGridFormat(sortedArr, false);
            setArrLocalDetails([...updatedLocalDetails][0]);
            if (updatedLocalDetails[0].find(obj => obj?.nToken === modalData?.data?.nToken)) {
                setSelectedIndice(modalData?.data?.nToken)
            }
            setInitialIndice(selectedExchange)
        }
    }, [localIndices, modalData])

    const handleClose = () => {
        dispatch(handleModal([{ "CHANGE_HEADER_INDICES": false }]));
        dispatch(handleModalData({}));
        setArrLocalDetails(null)
        setSelectedIndice(null)
        setSearchTerm("")
    }

    const handleToggleIndice = (data) => {
        let temp = headerIndices.findIndex(x => x?.nToken === data?.nToken)
        if (temp === -1) {
            setSelectedIndice(data?.nToken);
            onSelect(data, modalData?.index);
            handleClose();
        } else {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: "Index is already selected. Please choose a different index." }));
        }
    }

    const handleSearchIndice = useCallback((value) => {
        let temp = [];
        temp = arrLocalDetails?.filter(obj => {
            if (searchTerm === "") {
                return obj
            } else if (obj.sIndexDesc.toLowerCase().includes(value.toLowerCase())) {
                return obj
            } else {
                return null
            }
        })
        if (temp.length === 0) {
            setZeroState(true)
        }
    }, [arrLocalDetails, searchTerm])

    useEffect(() => {
        if (localIndices?.length) {
            let index = indiceExchangeList?.indexOf(modalData?.data?.exchangeName)
            onExchangeFilter(indiceExchangeList[index === -1 ? 0 : index])
        }
    }, [indiceExchangeList, localIndices, modalData, onExchangeFilter])
    return (
        <>
            <BzModal data-testid="change-header-indices-modal" size='sm' className='modal-breeze' show={modals['CHANGE_HEADER_INDICES']} onHide={handleClose} centered>
                <BzModalHeader>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={4} className='d-flex justify-content-start align-self-center'>
                                <div data-testid='change-header-indices-exchange-dropdown' className='screen-dropdown'>
                                    <BzDropdown>
                                        <Dropdown.Toggle className='btn-default'>{initialIndice}</Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {indiceExchangeList?.map((each) => <Dropdown.Item data-testid={`header-indices-dropdown-option-${each}`} key={each} onClick={() => onExchangeFilter(each)}>{each}</Dropdown.Item>
                                            )}
                                        </Dropdown.Menu>
                                    </BzDropdown>
                                </div>
                            </Col>
                            <Col md={7} className='d-flex justify-content-start align-self-center px-2 no-focus-textbox'>
                                <BzInputText data-testid='search_index_field_during_indice_change' size='sm' className='bdr-none font-regular scripname-searchtext' placeholder='Search Index' onChange={(e) => {
                                    setSearchTerm(e.target.value);
                                    setZeroState(false);
                                    handleSearchIndice(e.target.value);
                                }} autoFocus />
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-self-center'>
                                <div data-testid="change-header-indices-modal-close-icon" className='icon-16 icon-close icon-dark' onClick={handleClose}></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <Container className='p-0 mb-2'>
                        {arrLocalDetails?.filter(obj => {
                            if (searchTerm === "") {
                                return obj
                            } else if (obj.sIndexDesc.toLowerCase().includes(searchTerm.toLowerCase())) {
                                return obj
                            } else {
                                return null
                            }
                        }).map(obj =>
                            <Row className='g-0 py-1'>
                                <Col clasName='d-flex justify-content-start align-items-center'>
                                    <div className='form-check'>
                                        <input data-testid={`header-indices-index-list-${obj.sIndexDesc}-option`} name='theme' className='form-check-input' checked={obj?.nToken === selectedIndice} onChange={() => { handleToggleIndice(obj) }}
                                            value={obj?.nToken} type="radio" />
                                        <div className='font-medium font-size4 color-text'>{obj.sIndexDesc}</div>
                                    </div>
                                </Col>
                            </Row>
                        )}
                        {zeroState && searchTerm?.length > 0 ?

                            <div className='zero-state-alerts zero-state-alerts-xl'>
                                <Container fluid className='g-0'>
                                    <Row className='g-0'>
                                        <Col className='justify-content-center align-items-center text-center'>
                                            <div className='icon-64 icon-nodata mrgauto mb-3'></div>
                                            <div className='font-medium font-size4 color-text mb-1'>No matches found</div>
                                            <div className='font-regular font-size2 color-nodata'>Try adjusting your search to find what you are looking for</div>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                            : null}
                    </Container>
                </BzModalBody>
            </BzModal>
        </>
    )
}

export default ChangeHeaderIndicesModal
// Parshva S - 12/12/2023 - BT-123521 : Breeze - Header Indices End